<script lang="ts" setup>
    import { ref, watch } from 'vue'

    const props = defineProps(['modelValue', 'label'])
    const emit = defineEmits(['update:modelValue'])
    const selectedMonth = ref(props.modelValue || new Date().getMonth() + 1)

    watch(selectedMonth, newValue => {
        emit('update:modelValue', newValue)
    })

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ]
</script>

<template>
    <el-form-item :label="label">
        <el-select v-model="selectedMonth" placeholder="Select Month" size="large" class="w-100">
            <el-option v-for="month in months" :key="month.value" :label="month.label" :value="month.value" />
        </el-select>
    </el-form-item>
</template>

<style scoped>
    .w-100 {
        width: 100%;
    }
</style>
